<template>
  <article>
    <div>
      <span class="xbed-sub-title">公司/代理管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">蓝主人</BreadcrumbItem>
        <BreadcrumbItem>公司/代理管理</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Tabs v-model="tabValue" @on-click="changeTabs" style="margin-top:20px">
      <TabPane label="公司信息管理" name="name1">
        <Form inline>           
          <!-- <Select  v-model="formData.hotCity" @on-change="changeHotCity" style="width:200px">	
            <Option value="全部" key="0">全部</Option>                    														
          </Select>            -->
          <FormItem  label="查询" :label-width="55">
            <Input  v-model="formData.keyWord" @on-keyup="queryListByKeyWord" placeholder="请输入关键字"></Input>   
          </FormItem>
          <Button type="primary"  @click="addCompany" style="margin-bottom:10px">新增公司信息</Button>
        </Form>
        <Table :columns="tableData.columns" height='600' :loading = "tableData.loading" :data="tableData.list" @on-sort-change="sortId" ref="houseTable"></Table>
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :page-size="tableData.pageSize"  :total="tableData.count" :current="tableData.curpage" @on-page-size-change="companyInfoChangePageSize" @on-change="companyInfoChangePage"></Page>
        </div>
      </TabPane>
      <TabPane label="代理信息管理" name="name2">
        <Button @click="addAgencyInfo" type="primary" style="margin-bottom:20px">新增代理信息</Button>
        <Table :columns="agencyData.columns" height='600' :loading = "agencyData.loading" :data="agencyData.list"></Table>
        <div style="margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :page-size="agencyData.pageSize"  :total="agencyData.count" :current="agencyData.curpage" @on-page-size-change="agencyChangePageSize" @on-change="agencyChangePage"></Page>
        </div>
      </TabPane>        
    </Tabs>
    <Modal v-model = "agencyData.isShow" :loading=true @on-ok="submitAgencyInfo" title="新增代理信息" ref="submitAgency">
      <Form :model = "agencyData" :rules="agencyVlidate" ref="addAgencyForm">
        <FormItem  label="状态" :label-width="90">
          <Select  v-model="agencyData.status">						 
            <Option value = '1' :key="1">启用</Option>
            <Option value = '0' :key="0">禁用</Option>													
					</Select>
        </FormItem>
        <FormItem  label="性质" :label-width="90">
          <Select  v-model="agencyData.nature">						 
            <Option value='1' :key="1">企业</Option>
            <Option value='2' :key="2">个人</Option>													
					</Select>
        </FormItem>
        <FormItem prop="agencyName" label="名称" :label-width="90">
          <Input v-model="agencyData.agencyName"></Input>          
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model = "editAgencyData.isShow" :loading=true @on-ok = "submitEditAgency" title="编辑代理信息" ref="editAgency">
      <Form :model = "editAgencyData" ref = "editAgencyInfo">
        <FormItem  label="状态" :label-width="90">
          <Select  v-model = "editAgencyData.status">						 
            <Option value="1" :key="1">启用</Option>
            <Option value="0" :key="0">禁用</Option>													
					</Select>
        </FormItem>
        <FormItem  label="性质" :label-width="90">
          <Select  v-model = "editAgencyData.nature">						 
            <Option value = "1" :key="1">企业</Option>
            <Option value = "2" :key="2">个人</Option>													
					</Select>
        </FormItem>
        <FormItem  label="名称" :label-width="90">
          <Input v-model="editAgencyData.agencyName"></Input>          
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="addModalData.isShow" :loading=true  @on-ok="submitCompanyInfo" ref="addInfoModal" title="新增公司信息" ok-text="提交内容">
      <Form :model = "addModalData" :rules="ruleValidate" ref="addInfoForm">
        <FormItem prop="flag" label="状态" :label-width="90">
          <Select  v-model="addModalData.flag">						 
            <Option value='1' :key="1">启用</Option>
            <Option value='0' :key="0">禁用</Option>													
					</Select>
        </FormItem>
        <FormItem prop="province" label="注册省" :label-width="90">
          <Select  v-model="addModalData.province" @on-change="changeProvince" label-in-value>						 
            <Option :value="item.id" v-for="item in addModalData.provinces" :key="item.id">{{item.name}}</Option>									
					</Select>
        </FormItem>
        <FormItem prop="city" label="注册市" :label-width="90">
          <Select  v-model="addModalData.city" @on-change="changeCity" label-in-value>		
            <Option :value="item.id" v-for="item in addModalData.citys" :key="item.id">{{item.name}}</Option>													
					</Select>
        </FormItem>
        <FormItem prop="district" label="地区" :label-width="90">
          <Select  v-model="addModalData.district" @on-change="changeArea" label-in-value>						 
            <Option :value="item.id" v-for="item in addModalData.districts" :key="item.id">{{item.name}}</Option>													
					</Select>
        </FormItem>
        <FormItem prop="address" label="收件地址" :label-width="90">
          <Input v-model="addModalData.address"></Input>
        </FormItem>
        <FormItem prop="isSubsidiary" label="是否子公司" :label-width="100">
          <Select  v-model="addModalData.isSubsidiary">						 
            <Option :value="0" :key="0" >否</Option>												
            <Option :value="1" :key="1" >是</Option>
					</Select>
        </FormItem>
        <FormItem prop="companyName" label="公司名称" :label-width="90">
          <Input v-model="addModalData.companyName" :maxlength="120"></Input>
        </FormItem>
        <FormItem prop="legalName" label="法人代表" :label-width="90">
          <Input v-model="addModalData.legalName"></Input>
        </FormItem>
        <FormItem prop="phone" label="联系电话" :label-width="90">
          <Input v-model="addModalData.phone"></Input>
        </FormItem>
        <FormItem prop="bankName" label="开户行" :label-width="90">
          <Input v-model="addModalData.bankName"></Input>
        </FormItem>
        <FormItem prop="bankUser" label="户名" :label-width="90">
          <Input v-model="addModalData.bankUser"></Input>
        </FormItem>
        <FormItem prop="bankAccount" label="账号" :label-width="90">
          <Input v-model="addModalData.bankAccount"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="editModalData.isShow" :loading=true  @on-ok="submitEditInfo" ref="editInfoModal" title="编辑公司信息" ok-text="提交内容">
      <Form :model = "editModalData"  ref="editInfoForm">
        <FormItem prop="" label="状态" :label-width="90">
          <Select  v-model="editModalData.flag">						 
            <Option value='1' :key="1">启用</Option>
            <Option value='0' :key="0">禁用</Option>													
					</Select>
        </FormItem>
        <FormItem prop="" label="注册省" :label-width="90">
          <Select  v-model="editModalData.province" @on-change="editChangeProvince" label-in-value>						 
            <Option :value="item.id" v-for="item in editModalData.provinces" :key="item.id">{{item.name}}</Option>									
					</Select>
        </FormItem>
        <FormItem prop="" label="注册市" :label-width="90">
          <Select  v-model="editModalData.city" @on-change="editChangeCity" label-in-value>		
            <Option :value="item.id" v-for="item in editModalData.citys" :key="item.id">{{item.name}}</Option>													
					</Select>
        </FormItem>
        <FormItem prop="" label="地区" :label-width="90">
          <Select  v-model="editModalData.district" @on-change="editChangeArea" label-in-value>						 
            <Option :value="item.id" v-for="item in editModalData.districts" :key="item.id">{{item.name}}</Option>													
					</Select>
        </FormItem>
        <FormItem prop="" label="收件地址" :label-width="90">
          <Input v-model="editModalData.address"></Input>
        </FormItem>
        <FormItem prop="" label="是否子公司" :label-width="100">
          <Select  v-model="editModalData.isSubsidiary">						 
            <Option :value="0" :key="0" >否</Option>												
            <Option :value="1" :key="1" >是</Option>
					</Select>
        </FormItem>
        <FormItem prop="" label="公司名称" :label-width="90">
          <Input v-model="editModalData.companyName" :maxlength="120"></Input>
        </FormItem>
        <FormItem prop="" label="法人代表" :label-width="90">
          <Input v-model="editModalData.legalName"></Input>
        </FormItem>
        <FormItem prop="" label="联系电话" :label-width="90">
          <Input v-model="editModalData.phone"></Input>
        </FormItem>
        <FormItem prop="" label="开户行" :label-width="90">
          <Input v-model="editModalData.bankName"></Input>
        </FormItem>
        <FormItem prop="" label="户名" :label-width="90">
          <Input v-model="editModalData.bankUser"></Input>
        </FormItem>
        <FormItem prop="" label="账号" :label-width="90">
          <Input v-model="editModalData.bankAccount"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>
<script>
import Utils from "@/utils";
import API from "@/api";
// import companyAgency from "./company-info"
export default {
  created(){
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");    
    this.$Notice.config({
      top: 80,
    });
  },
  async mounted(){
    this.getProvince();
    this.getCompanyInfo();
    //this.getAgencyAll(); 
  },
  methods:{
    changeTabs(name){
      if(name =='name2'){//          
        this.getAgencyAll();
      }      
    },
    async getProvince(){		
			let resp =  (await API.omsAPI[this.env].php.provincesList());					
      this.addModalData.provinces  = resp.data; 
      this.addModalData.province  = resp.data[0].id;
      this.editModalData.provinces  = resp.data;            
    },
    async changeProvince(obj){//新增公司信息改变省份
      if(!obj.value){
        return
      }      
      let resp =  (await API.omsAPI[this.env].php.cityList({"id":obj.value}));		
      this.provinces = resp;      
      this.addModalData.citys = resp.data;
      this.addModalData.city = resp.data[0].id;       
      if(!obj.label){
        this.addModalData.tprovince = this.addModalData.provinces[0].name;//省名
      }else{
        this.addModalData.tprovince = obj.label;//省名
      }        
    },
    async changeCity(obj){//新增公司信息改变城市
      let resp =  (await API.omsAPI[this.env].php.countyslist({"id":obj.value}));		
      this.addModalData.districts = resp.data;
      this.addModalData.district = resp.data[0].id;
      // this.addModalData.tcity = obj.label;    
      if(!obj.label){
        this.addModalData.tcity = this.addModalData.citys[0].name;//市名
      }else{
        this.addModalData.tcity = obj.label;//市名
      }    
    },
    changeArea(obj){
      if(!obj.label){
        this.addModalData.tdistrict = this.addModalData.districts[0].name;//市名
      }else{
        this.addModalData.tdistrict = obj.label;//市名
      }
      //this.tableData.districts 
    },
    async editChangeProvince(obj){//公司信息编辑页改变省       
      if(!obj.value){
        return
      }
      this.editModalData.provinces.forEach((item)=>{       
        if(item.id == obj.value){          
          this.editModalData.provName = item.name;                       
        } 
      })
      let resp =  (await API.omsAPI[this.env].php.cityList({"id":obj.value}));
      this.editModalData.citys  = resp.data//城市初始化  
      if(this.editModalData.cityName) {
        this.editModalData.citys.forEach(item => {
          if(this.editModalData.cityName == item.name) {
            this.editModalData.city = Number(item.id)
          }
        })
      }else{
        this.editModalData.city  = Number(resp.data[0].id) ;//城市初始化   
      }
      if(obj.label){
        this.editModalData.tprovince = obj.label//this.addModalData.provinces[0].name;//省名
      }else{
        this.editModalData.tprovince = this.editModalData.provinces[0].name;//省名
      }      
    },
    async editChangeCity(obj){  //公司信息编辑页改变城市    
      let resp =  (await API.omsAPI[this.env].php.countyslist({"id":obj.value}));	
      this.editModalData.districts = resp.data;
      if(this.editModalData.districtName) {
        this.editModalData.districts.forEach(item => {
          if(item.name == this.editModalData.districtName) {
            this.editModalData.district = item.id;
          }
        })
      }else{
        this.editModalData.district = resp.data[0].id;
      }
      if(obj.value){
        this.editModalData.tcity = obj.value;
      } 
    },    
    editChangeArea(){
    },    
    async getCompanyInfo(){//获得所有公司信息
      this.tableData.loading = true;
      let respdata =  (await API.omsAPI[this.env].php.companyInfo()).data;//公司信息     
      if(respdata.retcode == 0){
        respdata.retdata.forEach(item=>{
          item.queryString = item.city + item.companyName + item.legalName +item.address
        })
        this.tempTableData = respdata.retdata;//暂存数据1
        this.sortId();
        // this.tableData.list = this.toCurPage(this.tableData.curpage,this.tempTableData,this.tableData.pageSize);
        this.keyTemp = respdata.retdata//暂存数据1
        this.tableData.count = respdata.retdata.length; 
        this.tableData.loading = false; 
        this.$Notice.success({
				title: '查询成功'
        });
      }else{
        this.$Notice.error({
				title: respdata.retmsg
        }); 
      }      
    },
    sortId(option = {}) {
      if(option.order) {
        this.tableData.curpage = 1
        this.sortType = option.order
      }
      let newArr = this.tempTableData.sort((a,b)=>{
        if(this.sortType === 'asc') {
          return a.companyInfoId - b.companyInfoId
        }
        return b.companyInfoId - a.companyInfoId
      })
      this.tableData.list = this.toCurPage(this.tableData.curpage, newArr, this.tableData.pageSize)
    },
    async addCompanyInfo(){//新增公司信息
      let params = {}
      let resp = ''
      params.flag = this.addModalData.flag;
      params.companyName = this.addModalData.companyName;
      params.legalName = this.addModalData.legalName;
      params.phone = this.addModalData.phone;
      params.address = this.addModalData.address;
      params.bankName = this.addModalData.bankName;
      params.bankUser = this.addModalData.bankUser;
      params.bankAccount = this.addModalData.bankAccount;
      params.isSubsidiary = this.addModalData.isSubsidiary+'';        
      params.province = this.addModalData.tprovince;
      params.city = this.addModalData.tcity;
      params.district = this.addModalData.tdistrict;      
      resp =  (await API.omsAPI[this.env].php.addCompanyInfo(params));
      if(resp.data.retcode == 1){
        this.$Notice.success({
				title: '新增成功'
        }); 
      }else{
        this.$Notice.error({
				title: resp.data.retmsg
        }); 
      }
      this.getCompanyInfo();
    },
    submitCompanyInfo(){
      this.$refs.addInfoModal.buttonLoading = false
      this.$refs.addInfoForm.validate((valid)=>{
        if(valid){         
          this.addCompanyInfo()  
          this.addModalData.isShow = false        
        }
      })
    },
    toCurPage(pageNum, originData, pagesize){//获得当前页的数据 originData:所有数据
      let arr = [],i=0,len = originData.length;      
      for(;i<len;i++){
          if((pageNum-1)*pagesize<=i && i<pagesize*pageNum)
          arr.push(originData[i]);
      }
      return arr;
    },
    agencyChangePageSize(pageSize){//代理信息改变pagesize
      this.agencyData.pageSize =pageSize
      this.getAgencyAll();
    },
    agencyChangePage(page){//代理信息改变页码
      this.agencyData.curpage =page
      this.getAgencyAll();
    },
    companyInfoChangePageSize(pageSize){//公司信息改变每页显示条数
      this.tableData.pageSize = pageSize;
      this.tableData.curpage = 1;
      this.tableData.list = this.toCurPage(this.tableData.curpage,this.tempTableData,this.tableData.pageSize);
    },
    companyInfoChangePage(pageNum){//公司信息改变页码
      this.tableData.curpage = pageNum;
      this.tableData.list = this.toCurPage(this.tableData.curpage,this.tempTableData,this.tableData.pageSize);
    },
    queryListByKeyWord(){//关键字查询公司信息管理
      let arr = []
      this.keyTemp.forEach((item)=>{
        if(this.isContain(item.queryString,this.formData.keyWord)){
          arr.push(item);
        } 
      })
      this.tempTableData = arr;
      this.tableData.curpage = 1;
      this.tableData.count = arr.length;      
      this.tableData.list = this.toCurPage(this.tableData.curpage,this.tempTableData,this.tableData.pageSize);//显示当前页  
    },
    isContain(str,substr){//字符串搜索匹配      
        return str.indexOf(substr)>=0; 
    },
    addCompany(){
      this.addModalData.isShow = true;  
      this.addModalData.address = ''  
      this.addModalData.companyName = ''
      this.addModalData.legalName = ''
      this.addModalData.phone = ''
      this.addModalData.bankName = ''
      this.addModalData.bankUser = ''//户名
      this.addModalData.bankAccount = ''
      this.addModalData.cityName = ''
    },
    editModal(params){//编辑公司信息管理
      let province = params.row.province
      this.editModalData.isShow = true     
      this.editModalData.flag = params.row.flag
      this.editModalData.companyName = params.row.companyName
      this.editModalData.legalName = params.row.legalName
      this.editModalData.phone = params.row.phone
      this.editModalData.address = params.row.address
      this.editModalData.bankName = params.row.bankName
      this.editModalData.bankUser = params.row.bankUser
      this.editModalData.bankAccount = params.row.bankAccount  
      this.editModalData.companyInfoId = params.row.companyInfoId      
      this.editModalData.isSubsidiary = Number(params.row.isSubsidiary)
      console.info(params)
      this.editModalData.provinces.forEach((item)=>{       
        if(item.name == province){          
          this.editModalData.province = item.id;//选中当前的省份
          this.editModalData.provName = item.name;                       
        } 
      })
      this.editModalData.cityName = params.row.city
      this.editModalData.districtName = params.row.district
      console.info(this.editModalData)
    },
    async submitEditInfo(){//提交编辑公司信息
      this.$refs.editInfoModal.buttonLoading = false
      let obj = {}
      obj.flag = this.editModalData.flag  
      obj.companyName = this.editModalData.companyName  
      obj.legalName = this.editModalData.legalName  
      obj.phone = this.editModalData.phone  
      obj.address = this.editModalData.address  
      obj.bankName =  this.editModalData.bankName  
      obj.bankUser =  this.editModalData.bankUser  
      obj.bankAccount = this.editModalData.bankAccount  
      obj.province = this.editModalData.provName
      obj.isSubsidiary = this.editModalData.isSubsidiary
      obj.companyInfoId =  this.editModalData.companyInfoId
      this.editModalData.citys.forEach((item)=>{       
        if(item.id == this.editModalData.city){          
          obj.city = item.name;                       
        } 
      })
      this.editModalData.districts.forEach((item)=>{       
        if(item.id == this.editModalData.district){
          obj.district = item.name;
        } 
      })      
      let resp =  (await API.omsAPI[this.env].php.editCompanyInfo(obj));
      if(resp.data.retcode == 1){
        this.$Notice.success({
				title: '编辑成功'
        });
      }else{
        this.$Notice.error({
				title: '编辑失败'
        });        
      }
      this.editModalData.isShow = false
      this.getCompanyInfo();
    },
    changeHotCity(){
    },
    async getAgencyAll(){//获得所有代理信息列表
      this.agencyData.loading = true;
      let obj = {}
      obj.page = this.agencyData.curpage
      obj.pageSize = this.agencyData.pageSize      
      let resp =  (await API.omsAPI[this.env].bluehost.getAgencyFindAll(obj,this.token)).data;//获得街道   
      this.agencyData.count =resp.total;
      this.agencyData.list =resp.content
      this.agencyData.loading = false;
    },
    addAgencyInfo(){
      this.agencyData.isShow = true;
      this.agencyData.agencyName = '';
    },
    async submitAgency(){
      let obj ={}
      obj.agencyName = this.agencyData.agencyName;
      obj.nature = this.agencyData.nature;
      obj.status = this.agencyData.status;
      let resp =  (await API.omsAPI[this.env].bluehost.AgencyAdd(obj,this.token));
      if(resp.data.retCode==51020000){
        this.$Notice.error({
        title: '新增失败'
        });       
      }else{
        this.$Notice.success({
        title: '新增成功'
        });
        this.agencyData.isShow = false;
        this.getAgencyAll()
      }
    },
    submitAgencyInfo(){//提交新增代理信息
      this.$refs.submitAgency.buttonLoading = false 
      this.$refs.addAgencyForm.validate((valid)=>{
        if(valid){          
          this.submitAgency()
        }
      })      
    },
    async submitEditAgency(){//提交编辑代理信息
      this.$refs.editAgency.buttonLoading = false
      let obj ={};
      obj.agencyName = this.editAgencyData.agencyName;
      obj.nature = this.editAgencyData.nature;
      obj.status = this.editAgencyData.status;
      obj.id = this.editAgencyData.id;
      let resp =  (await API.omsAPI[this.env].bluehost.updateAgency(obj,this.token));//获得街道      
      if(resp.data.retCode==51020000){
        this.$Notice.error({
				title: '编辑失败'
        });
        this.editAgencyData.isShow =false
      }else{
        this.$Notice.success({
				title: '编辑成功'
        });
      }
      this.editAgencyData.isShow = false
      this.getAgencyAll()
    },
    editAgencyInfo(row){//编辑代理信息
      this.editAgencyData.isShow = true;
      this.editAgencyData.nature = row.nature + '';
      this.editAgencyData.status = row.status + '';
      this.editAgencyData.agencyName = row.agencyName;
      this.editAgencyData.id = row.id;  
    },
    validat(a,value,callback){      
      if(value.length ==0){        
        callback(new Error('不能为空'));
      }
      if(value.length>50){        
        callback(new Error('最多50个字符'));
      }      
      callback();      
		},
  },
  data(){
    return {
      sortType: 'desc',
      tabValue:'',
      formData:{
        hotCity:'全部',
        keyWord:''
      },
      agencyVlidate:{
        agencyName:[
          {trigger:'blur',validator:this.validat}          
        ]
      },
      ruleValidate:{
        flag:[
					{required:true,  message: '不能为空', trigger:'blur'}
        ],
        companyName:[
					{required:true, message: '不能为空', trigger:'blur'}
        ],
        legalName:[
					{required:true, message: '不能为空', trigger:'blur'}
        ],
        phone:[
          {required:true, message: '不能为空', trigger:'blur'},
          {pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message:'手机号格式不正确',trigger:'blur'}
        ],
        address:[
					{required:true,  message: '不能为空', trigger:'blur'}
        ],
        bankName:[
					{required:true, message: '不能为空', trigger:'blur'}
        ],
        bankUser:[
					{required:true,  message: '不能为空', trigger:'blur'}
        ],
        bankAccount:[
					{required:true,  message: '不能为空', trigger:'blur'}
        ],
        province:[
					{required:true,type:'number', message: '不能为空', trigger:'blur'}
        ],
        city:[
					{required:true,type:'number', message: '不能为空', trigger:'blur'}
        ],
        district:[
					{required:true, type:'number', message: '不能为空', trigger:'blur'}
        ],
        isSubsidiary:[
					{required:true, type:'number',  message: '不能为空', trigger:'blur'}
				]
      },
      addModalData:{
        isShow:false,
        flag:'1',
        companyName:'',
        legalName:'',
        phone:'',
        address:'',
        bankName:'',
        bankUser:'',
        bankAccount:'',
        province:'',
        provinces:[],
        city:'',
        citys:[],
        district:'',
        districts:[],
        isSubsidiary:0
      },
      editModalData:{
        isShow:false,
        flag:'1',
        companyName:'',
        legalName:'',
        phone:'',
        address:'',
        bankName:'',
        bankUser:'',
        bankAccount:'',
        province:'null',
        provinces:[],
        city:'',
        citys:[],
        district:'',
        districts:[],
        isSubsidiary:0
      },
      tableData:{
        list:[],
        count:0,
        curpage:1,
        pageSize:10,
        columns:[
          {
            title:"ID",
            key: "companyInfoId",
            sortable:true,
            align: "center",
            width: 100
          },
          {
            title:"城市",
            key: "city",
            align: "center",
            width: 80
          },
          {
            title:"公司名",
            key: "companyName",
            align: "center",
            width: 240
          },
          {
            title:"是否子公司",
            key: "isSubsidiary",
            align: "center",
            width: 150,
            render:(h,params)=>{
              let str = ''
              if(params.row.isSubsidiary){
                str = "是"
              }else{
                str = "否"
              }
              return h("span",`${str}`);
            }
          },
          {
            title:"法人代表",
            key: "legalName",
            align: "center",
            width: 100
          },
          {
            title:"电话",
            key: "phone",
            align: "center",
            width: 100
          },
          {
            title:"详细地址",
            key: "address",
            align: "center",
            width: 250
          },
          {
            title:"银行信息",
            key: "bankName",
            align: "center",
            width: 240
          },
          {
            title:"状态",
            key: "flagText",
            align: "center",
            width: 100,
            render:(h,params)=>{
              if(params.row.flag){
                params.row.flagText = '启用'
              }else{
                params.row.flagText = '禁用'
              }
              return h("span",{},`${params.row.flagText}`)
            }
          },
          {
            title:"操作",             
            align: "center",
            width: 100,
            render:(h,params)=>{
              return h('Button',{
                on:{
										click:()=>{
                      this.editModal(params)											
										}
                },
                props:{
                  type:"primary"
                }
              },"编辑")
            }
          },
        ]
      },
      editAgencyData:{
        isShow:false,       
        agencyName:'',
        nature:'1',
        status:'1',
      },
      agencyData:{
        loading:false,
        pageSize:10,
        count:0,
        curpage:1,
        isShow:false,
        list:[],
        agencyName:'',
        nature:'1',
        status:'1',
        columns:[
          {          
            title:"ID",
            key: "id",
            align: "center",
            width: 100          
          },
          {          
            title:"代理名称",
            key: "agencyName",
            align: "center",
            width: 150          
          },
          {          
            title:"性质",
            key: "nature",
            align: "center",
            width: 100,
            render:(h,params)=>{
              let str = '';
              if(params.row.nature == 1){
                str = '企业'
              }else{
                str = '个人'
              }
              return h("span",`${str}`);
            }          
          },
          {          
            title:"状态",
            key: "status",
            align: "center",
            width: 100,
            render:(h,params)=>{
              let str = '';
              if(params.row.status == 1){
                str = '启用'
              }else{
                str = '禁用'
              }
              return h("span",`${str}`);
            }          
          },
          {          
            title:"操作",            
            align: "center",
            width: 100,
            render:(h,params)=>{              
               console.info(params)
              return h("Button",{
                on:{
										click:()=>{
                      this.editAgencyInfo(params.row)
                      //alert(params)                     																					
										}
                },
                props:{
                  type:"primary"
                }
              },'编辑');
            }          
          }
        ]
      }
    }
  },
  components:{
    // companyAgency
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/blue-hoster/company-info.vue